import React from 'react';
import {
  Group,
  Header as CLHeader,
  Typography,
} from '@qred/components-library';

const Header = () => (
  <CLHeader height={90}>
    <Group justify="flex-start" align="center">
      <Typography size="xxl" lineHeight="xxl" m="1em" weight={500}>
        Qredster AB
      </Typography>
    </Group>
  </CLHeader>
);

export default Header;
